/* global store */

import 'core-js/stable/object/from-entries'
import 'regenerator-runtime/runtime'
import { Notifier } from '@airbrake/node'
import electron from 'electron'
import { build, expander, init, path } from './helpers'

const airbrake = new Notifier({
  environment: ENVIRONMENT, // eslint-disable-line no-undef
  ignoreWindowError: true,
  instrumentation: {
    console: false,
  },
  projectId: AIRBRAKE_PROJECT_ID, // eslint-disable-line no-undef
  projectKey: AIRBRAKE_PROJECT_API_KEY, // eslint-disable-line no-undef
})

const populate = tabs => {
  try {
    const setTouchBar =
      'remote' in electron ? electron.remote.getCurrentWindow().setTouchBar : window ? window.setTouchBar : null

    const TouchBar = 'TouchBar' in electron ? electron.TouchBar : 'remote' in electron ? electron.remote.TouchBar : null

    if (TouchBar) {
      const { TouchBarButton } = TouchBar

      setTouchBar(
        new TouchBar({
          items: tabs.map(build).map(config => new TouchBarButton(config)),
        }),
      )
    } else {
      console.error('Touch Bar not supported or not found')
    }
  } catch (error) {
    // no correction
    airbrake.notify(error)
  }
}

// eslint-disable-next-line unicorn/prevent-abbreviations
exports.getTabsProps = (_, properties) => {
  try {
    const { tabs } = properties
    const { termGroups, sessions } = store.getState()
    const activeSessionList = termGroups.activeSessions
    const sessionList = sessions.sessions

    Promise.all(
      tabs.map(async tab => {
        const session = activeSessionList[tab.uid]
        const { pid } = sessionList[session]

        const directory = await path(pid)

        return {
          ...tab,
          directory,
          pid,
          session,
        }
      }),
    )
      .then(populate)
      .catch(airbrake.notify)
  } catch (error) {
    // no correction
    airbrake.notify(error)
  }

  // return properties, expected by hyper
  return properties
}

// eslint-disable-next-line unicorn/consistent-function-scoping
exports.middleware = _ => next => action => {
  const { config, type } = action

  switch (type) {
    case 'CONFIG_LOAD':
    case 'CONFIG_RELOAD':
      if (config.touchbarSwitcher) {
        expander(config.touchbarSwitcher)
      }

      break
    default:
      break
  }

  next(action)
}

init()
